import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer>
      <p className="disclaimer">{t('footer.product')}</p>
      <p className="disclaimer">
        {t('footer.info1')}<br />
        {t('footer.info2')} <a href='mailto:info@upyachat.com'>info@upyachat.com</a> {t('footer.info3')}
      </p>
    </footer>
  );
};

export default Footer;
